import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function QuesonSection() {
  return (
    <>
      <PostSection id="que-son-ai-overviews" title="¿Qué son los AI Overviews de Google?">
        <p>
          Si has buscado algo en Google recientemente, probablemente hayas notado un cambio: antes de los enlaces 
          tradicionales, aparece un <strong>resumen generado por inteligencia artificial</strong> que intenta responder 
          tu pregunta directamente. Eso son los <strong>AI Overviews</strong>, y en 2026 están transformando por 
          completo la forma en que los usuarios interactúan con el buscador.
        </p>

        <PostHighlight>
          En 2026, entre el 30% y el 35% de todas las búsquedas en Google ya muestran AI Overviews, 
          citando entre 4 y 6 fuentes por respuesta.
        </PostHighlight>

        <h3 id="como-funcionan" className="text-xl font-bold text-white mt-8 mb-4">
          Cómo funcionan en 2026
        </h3>
        <p>
          Los AI Overviews utilizan modelos de lenguaje avanzados para sintetizar información de múltiples fuentes 
          web y presentarla como una respuesta coherente. A diferencia de los fragmentos destacados tradicionales, 
          estos resúmenes son <strong>conversacionales</strong>: el usuario puede hacer preguntas de seguimiento 
          sin salir del buscador.
        </p>
        <p className="mt-4">
          La evolución desde su lanzamiento ha sido notable:
        </p>
        <ul className="list-disc pl-6 space-y-2 mt-4">
          <li><strong>Cobertura:</strong> del 15% en 2024 al 30-35% en 2026</li>
          <li><strong>Fuentes citadas:</strong> de 3-4 a 4-6 por respuesta</li>
          <li><strong>Longitud:</strong> de 100-200 palabras a 150-300 palabras</li>
          <li><strong>Capacidad conversacional:</strong> de limitada a completamente interactiva</li>
          <li><strong>Respuestas multimodales:</strong> ahora incluyen texto e imágenes</li>
        </ul>

        <h3 id="datos-clave" className="text-xl font-bold text-white mt-8 mb-4">
          Datos clave: cobertura y alcance
        </h3>
        <p>
          Según estudios de Seenos.ai sobre más de 50.000 consultas en 12 verticales, los AI Overviews ya no son 
          un experimento: son una <strong>capa fundamental de la búsqueda</strong>. Las consultas informativas son 
          las más afectadas, mientras que las búsquedas locales y navegacionales se mantienen relativamente estables.
        </p>
      </PostSection>
    </>
  );
}
